import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { filePathWithBaseURL, fileType } from 'src/app/core/helpers/helperfunc';
import { LoaderService } from 'src/app/core/services/loader/loader.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-doc-viewer',
  templateUrl: './doc-viewer.component.html',
  styleUrls: ['./doc-viewer.component.scss']
})
export class DocViewerComponent implements OnInit {
  image: any;
  base_url = 'https://docs.google.com/gview?url=%URL%&embedded=true';

  constructor(
    public dialogRef: MatDialogRef<DocViewerComponent>, 
    @Inject(MAT_DIALOG_DATA) public doc: any, 
    private _loaderService: LoaderService
  ) { }

  ngOnInit(): void {
    if (fileType(this.doc.path)) {
      this.image = filePathWithBaseURL(this.doc?.path);
    } else {
      // this._loaderService.showLoader();
      this.doc.path = filePathWithBaseURL(this.doc?.path);
    }
    
  }

  close() {
    this.dialogRef.close(true);
  }

  contentLoaded() {
    this._loaderService.hideLoader();
  }
}
